import React,{useState, useEffect} from 'react'
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import { PageTitle } from '../../../../../_template/layout/core/PageData';
import { toAbsoluteUrl } from '../../../../../_template/helpers/CommonFunction';

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

const Deployments = () => {
    const loginUserType = localStorage.getItem('type');

    let pageTitle;
    if(loginUserType === 'A'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
            {
                title: 'Guide',
                path: '/guide/overview',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    else if(loginUserType === 'D'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }


    

    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const deployingImgArr = [
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_0.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_1.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_2.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_3.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_4.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_5.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_6.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_7.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_8.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_9.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_10.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_11.png') },
        { src: toAbsoluteUrl('saiFile/deployingAgents/img_12.png') },
    ];

    useEffect(() => {
        const links = document.querySelectorAll(".sidebar-link");
        links.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                const targetId = link.getAttribute("data-bs-target").substring(1);
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 100,
                    behavior: "smooth",
                });
                }
                links.forEach((l) => l.classList.remove("guide-active"));
                link.classList.add("guide-active");
            });
        });
        return () => {
            links.forEach((link) => {
                link.removeEventListener("click", () => {});
            });
        };
    }, []);

    return (
        <>
            <style>
                {
                    `
                        .th-blr {
                            border-bottom-left-radius: 0.475rem;
                            border-top-left-radius: 0.475rem;
                        }
                        .th-brr {
                            border-bottom-right-radius: 0.475rem;
                            border-top-right-radius: 0.475rem;
                        }
                        .my-json-wrapper .__json-pretty__ {
                            font-size: 15px;
                            padding: 15px;
                            border-radius: 0.475rem;
                        }
                        .header-json-wrapper .__json-pretty__ {
                            font-size: 15px;
                            background: #ffffff;
                            color: #7e8299;
                        }
                        .yarl__container {
                            background-color: #00000099 !important;
                            backdrop-filter: blur(3px) !important;
                        }
                        .yarl__navigation_next {
                            display: none !important;
                        }
                        .yarl__navigation_prev {
                            display: none !important;
                        }
                        .side-custom-bg {
                            background: #f7fafe !important;
                        }
                        .guide-active span {
                            color: var(--sai-text-primary) !important;
                        }
                    `
                }
            </style>
            <PageTitle breadcrumbs={pageTitle}>
                Deployments
            </PageTitle>
            
            <div className="row">
                <div className="col-md-9 col-12">
                    <div className="card card-flush border">
                        <div className="card-header mt-5">
                            <div className="card-title align-items-start flex-column">
                                <h2 className="card-label fw-bold text-gray-800 fs-3x mb-4">
                                    Deployments
                                </h2>
                                <span className="text-gray-800 mt-2 fw-bold fs-1x mb-4">Users from all channels</span>
                            </div>
                        </div>
                        <div className="card-body pt-2">
                            <div id="chat_mode">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Chat Mode
                                    </h4>
                                    <div className='border border-dashed rounded border-gray-400 p-5'>
                                        <img
                                            className="w-100 cursor-pointer" 
                                            alt="Logo"
                                            src={deployingImgArr[12].src}
                                            onClick={() => { setOpen(true); setCurrentIndex(12) }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='row' id="using_truChat_widget">
                                <div className='col-md-12'>
                                    <div className="mb-8">
                                        <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                                            Using TruChat Widget
                                        </h4>
                                        <div className="my-2 ms-5">
                                            <div className="d-flex align-items-center mb-6 lh-lg">
                                                <div className="text-gray-800 fw-semibold fs-6">
                                                    TruChat Widget is a feature rich widget which you can deploy on any web page. If you choose this option, you will find a simple “Script”. This script can be implemented on any web page in a matter of minutes. And Voila your Agent is ready on your website.
                                                    <div className='mt-3 mb-3' style={{textDecoration: 'underline'}}>
                                                        Note that, to test the Agent before going live, you can implement the “Script” on a private page instead of your website.
                                                    </div>
                                                    You can also implement the “Script” on multiple pages wherever you want the Agent to interact with the website visitors.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row' id="using_other_widgets">
                                <div className='col-md-12'>
                                    <div className="mb-8">
                                        <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                                            Using Other Widgets
                                        </h4>
                                        <div className="my-2 ms-5">
                                            <div className="d-flex align-items-center mb-6 lh-lg">
                                                <div className="text-gray-800 fw-semibold fs-6">
                                                    For integrating with any other Widget, you can use the Webhook API.
                                                    <div className='mt-3 mb-3'>
                                                        If you are looking to integrate with popular channels like WhatsApp, SMS, Telegram and so on, please refer to <span className="text-primary">Channels</span> 
                                                    </div>
                                                    If you are looking to create Voice Agents, refer to <span className="text-primary">Voice Agents</span> .
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-10' id="get_business_list">
                                <div className='col-md-12'>
                                    <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                                        Get Business List
                                    </h4>
                                </div>
                                <section className='ms-5'>
                                    <div className='col-md-12'>
                                        <div className="row mb-2 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Url
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    https://api.truvoice.in/api/get-biz-list
                                                </span>                
                                            </div>
                                        </div>
                                        <div className="row mb-7 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Method
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    POST
                                                </span>                
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-4">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            auth_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            TruBot_auth
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            auth_digest
                                                        </td>
                                                        <td className='text-dark'>
                                                            fc5d988d9d2197c15ce0b4857624c091
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    auth_id: "TruBot_auth",
                                                    auth_digest: "fc5d988d9d2197c15ce0b4857624c091",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-success fs-5 fw-bold">
                                            <span className="bg-light-success p-2 rounded">
                                                Success
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    status: "success",
                                                    message: "",
                                                    data: {
                                                        business_list: [
                                                            {
                                                                business_id: "NTY00DEzMjg2Mw==",
                                                                secret_key: "987654123",
                                                                business_name: "Lipozene"
                                                            }
                                                        ],
                                                    }
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-danger fs-5 fw-bold">
                                            <span className="bg-light-danger p-2 rounded">
                                                Error
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    status: "error",
                                                    message: "Secret key dose not match",
                                                    data: {}
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-1'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[0].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(0) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mt-10'>
                                       <p className="text-success fs-5 fw-bold">
                                            <span className="bg-light-success p-2 rounded">
                                                Success
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-1'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[1].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(1) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mt-10'>
                                       <p className="text-danger fs-5 fw-bold">
                                            <span className="bg-light-danger p-2 rounded">
                                                Error
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-1'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[2].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(2) }}
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className='row mb-10' id="receive_message_from_widget">
                                <div className='col-md-12'>
                                    <h4 className="text-gray-900 fs-1 fw-bold mb-6">
                                        Agent receive Message from widget
                                    </h4>
                                </div>
                                <section className='ms-5'>
                                    <div className='col-md-12'>
                                        <div className="row mb-2 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Url
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    https://multihook.truvoice.in/webhooks/custom/webhook
                                                </span>                
                                            </div>
                                        </div>
                                        <div className="row mb-7 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Method
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    POST
                                                </span>                
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className="alert alert-info d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <span className='fw-bold'>
                                                    You need to provide us hook URL where we will send message that user will send from widget.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            Text message
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-4">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            text
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            hi
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            5455574455
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7",
                                                    room_id: 'mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq',
                                                    msg_type: 'text',
                                                    message: 'hi',
                                                    message_id: '5455574455',
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-1'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[3].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(3) }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-5">
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Response Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            intent
                                                        </td>
                                                        <td className='text-dark'>
                                                            service
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            This is AI predicted intent.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            conversation_entity
                                                        </td>
                                                        <td className='text-dark'>
                                                            By lipozene
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            This is AI predicted conversation entity.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            action
                                                        </td>
                                                        <td className='text-dark'>
                                                            By lipozene
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            This is AI predicted action.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            information
                                                        </td>
                                                        <td className='text-dark'>
                                                            your information
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            This is AI predicted information.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            5455574455
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            This is AI predicted message_id.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-5">
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Response Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    status: "success",
                                                    data: {
                                                        intent: "service",
                                                        conversation_entity: "By lipozene",
                                                        action: "By lipozene",
                                                        information: "your information",
                                                        message_id: "5455574455",
                                                        room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq"
                                                    }
                                                }}
                                            />
                                        </pre>
                                    </div>




                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            Message with file
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in form-data.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            file
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            <FontAwesomeIcon className='me-1' icon={faAngleDown} />
                                                            file_data
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            binary
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            originalName
                                                        </td>
                                                        <td className='text-dark'>
                                                            testimg.jpg
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            filePath
                                                        </td>
                                                        <td className='text-dark'>
                                                            storage/frontend-chat/undefined/1739440754629
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            fileType
                                                        </td>
                                                        <td className='text-dark'>
                                                            image/jpeg
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            fileSize
                                                        </td>
                                                        <td className='text-dark'>
                                                            9244
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "file",
                                                    message: "",
                                                    file_data: [
                                                        {
                                                            originalName: "testimg.jpg",
                                                            filePath: "storage/frontend-chat/undefined/1739440754629",
                                                            fileType: "image/jpeg",
                                                            fileSize: "9244",
                                                        },
                                                        {
                                                            originalName: "blob",
                                                            filePath: "storage/frontend-chat/undefined/1739440754629",
                                                            fileType: "image/jpeg",
                                                            fileSize: "9244",
                                                        }
                                                    ],
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[4].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(4) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            Message with button
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in form-data.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            button
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            {`{“type”: “button”, “label”: “Yes”, “bg_color”: “#111111”, “text_color”: “#FFFFFF”, “value”: “Y”}`}
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "button",
                                                    message: "{“type”: “button”, “label”: “Yes”, “bg_color”: “#111111”, “text_color”: “#FFFFFF”, “value”: “Y”}",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[5].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(5) }}
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className='row mb-10' id="send_message_using_agent">
                                <div className='col-md-12'>
                                    <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                                        Send Message Using Agent
                                    </h4>
                                </div>
                                <section className='ms-5'>
                                    <div className='col-md-12'>
                                        <div className="row mb-2 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Url
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    https://api.truvoice.in/bot/bot-send-message
                                                </span>                
                                            </div>
                                        </div>
                                        <div className="row mb-7 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Method
                                            </label>
                                            <div className="col-lg-8">                    
                                                <span className="fw-semibold text-gray-600">
                                                    POST
                                                </span>                
                                            </div>
                                        </div>
                                        <div className="row mb-7 fs-6">
                                            <label className="col-lg-2 fw-bold text-muted">
                                                Headers
                                            </label>
                                            <div className="col-lg-8">
                                                <pre className='header-json-wrapper'>
                                                    <JSONPretty 
                                                        data={{
                                                            'Content-Type': "application/json",
                                                            'business-id': "NTY0ODEzMjg2Mw==",
                                                            'secret-key': "bot963852741",
                                                        }}
                                                    />
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            Text message
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            text
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            I am agent
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "text",
                                                    message: "I am agent",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-5'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[6].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(6) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            For button
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            button
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            This is button
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            <FontAwesomeIcon className='me-1' icon={faAngleDown} />
                                                            content
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            label
                                                        </td>
                                                        <td className='text-dark'>
                                                            Yes
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bg_color
                                                        </td>
                                                        <td className='text-dark'>
                                                            #111111
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            Only hex code accepted.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            text_color
                                                        </td>
                                                        <td className='text-dark'>
                                                            #FFFFFF
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            Only hex code accepted.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            action
                                                        </td>
                                                        <td className='text-dark'>
                                                            click
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            value
                                                        </td>
                                                        <td className='text-dark'>
                                                            Y
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "button",
                                                    message: "this is button",
                                                    content: [
                                                        {
                                                            label: "Yes",
                                                            bg_color: "#111111",
                                                            text_color: "#FFFFFF",
                                                            action: "click",
                                                            value: "Y",
                                                        },
                                                        {
                                                            label: "No",
                                                            bg_color: "#000000",
                                                            text_color: "#FFFFFF",
                                                            action: "click",
                                                            value: "N",
                                                        }
                                                    ],
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                       <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[7].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(7) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            For Link
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            link
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            This is link
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            url
                                                        </td>
                                                        <td className='text-dark'>
                                                            https://www.youtube.com
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            name
                                                        </td>
                                                        <td className='text-dark'>
                                                            test link
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "link",
                                                    message: "this is link",
                                                    url: "https://www.youtube.com",
                                                    name: "test link",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[8].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(8) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            For Video
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            video
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            This is video
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            url
                                                        </td>
                                                        <td className='text-dark'>
                                                            http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            Need to add public accessible url only
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "video",
                                                    message: "this is video",
                                                    url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[9].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(9) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            For Audio
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in body raw.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            audio
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            This is audio
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            url
                                                        </td>
                                                        <td className='text-dark'>
                                                            https://commondatastorage.googleapis.com/codeskulptor-assets/sounddogs/soundtrack.mp3
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td>
                                                            Need to add public accessible url only
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "audio",
                                                    message: "this is audio",
                                                    url: "https://commondatastorage.googleapis.com/codeskulptor-assets/sounddogs/soundtrack.mp3",
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[10].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(10) }}
                                            />
                                        </div>
                                    </div>

                                    <div className='col-md-12 mb-5 mt-10'>
                                        <h4 className="text-gray-800 fw-bold mb-6">
                                            For File
                                        </h4>
                                        <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                                            <div className="d-flex flex-column">
                                                <h4 className="mb-1 text-primary mb-6">NOTE:</h4>
                                                <span>
                                                    Request parameter need to send in form-data.
                                                </span>
                                            </div>
                                        </div>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Request Example
                                            </span>
                                        </p>
                                        <div className='table-responsive'>
                                            <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 table-bordered">
                                                <thead className='bg-light-dark'>
                                                    <tr className="fs-7 fw-bold text-gray-500">                                    
                                                        <th className="th-blr ps-2" style={{width:'100px'}}>Key</th>
                                                        <th className="" style={{width: '200px'}}>Example Data</th>
                                                        <th className="" style={{width: '150px'}}>Is required</th>
                                                        <th className="" style={{width: '150px'}}>Data type</th>  
                                                        <th className="th-brr">Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            bot_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            sender_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            991658828894132
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            receiver_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            NF7FXa9d-C_IK_WHAAAF
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            room_id
                                                        </td>
                                                        <td className='text-dark'>
                                                            mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            msg_type
                                                        </td>
                                                        <td className='text-dark'>
                                                            file
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            message
                                                        </td>
                                                        <td className='text-dark'>
                                                            This is file
                                                        </td>
                                                        <td className='text-danger'>
                                                            Required
                                                        </td>
                                                        <td className='text-dark'>
                                                            string
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            <FontAwesomeIcon className='me-1' icon={faAngleDown} />
                                                            file_data
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            binary
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            originalName
                                                        </td>
                                                        <td className='text-dark'>
                                                            blob
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            filePath
                                                        </td>
                                                        <td className='text-dark'>
                                                            Storage/frontend-chat/5648132863/1739510530301
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            fileType
                                                        </td>
                                                        <td className='text-dark'>
                                                            image/jpeg
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-primary'>
                                                            fileSize
                                                        </td>
                                                        <td className='text-dark'>
                                                            155524
                                                        </td>
                                                        <td className='text-danger'>
                                                            
                                                        </td>
                                                        <td className='text-dark'>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                JSON Request Example
                                            </span>
                                        </p>
                                        <pre className='my-json-wrapper'>
                                            <JSONPretty 
                                                data={{
                                                    bot_id: "991658828894132",
                                                    sender_id: "991658828894132",
                                                    receiver_id: "NF7FXa9d-C_IK_WHAAAF",
                                                    room_id: "mUSnVxCQ1D5c65Dfnpig90BICLnEDRhq",
                                                    msg_type: "file",
                                                    message: "this is file",
                                                    file_data:[
                                                        {
                                                            originalName: "blob",
                                                            filePath: "storage/frontend-chat/5648132863/1739510530301",
                                                            fileType: "image/jpeg",
                                                            fileSize: "155524",
                                                        },
                                                        {
                                                            originalName: "blob",
                                                            filePath: "storage/frontend-chat/5648132863/1739510530609",
                                                            fileType: "image/jpeg",
                                                            fileSize: "55629",
                                                        },
                                                        {
                                                            originalName: "blob",
                                                            filePath: "storage/frontend-chat/5648132863/1739510530726",
                                                            fileType: "image/jpeg",
                                                            fileSize: "22345",
                                                        }
                                                    ]
                                                }}
                                            />
                                        </pre>
                                    </div>
                                    <div className='col-md-12'>
                                        <p className="text-gray-800 fs-5 fw-bold">
                                            <span className="bg-light-dark p-2 rounded">
                                                Postman Example
                                            </span>
                                        </p>
                                        <div className='border border-dashed rounded border-gray-400 p-4'>
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={deployingImgArr[11].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(11) }}
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card position-fixed fill-wd">
                        <div className="card-body card-rounded px-0 px-6 py-6 side-custom-bg" bis_skin_checked="1" >
                            <ul id="kt_sidebar_nav" className="nav nav-flush menu menu-column menu-title-gray-600 menu-bullet-gray-600 menu-state-primary fw-bold fs-6 mb-8">
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#chat_mode"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Chat mode
                                        </span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#using_truChat_widget"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Using TruChat widget
                                        </span>
                                    </button>
                                </li> 
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#using_other_widgets"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Using other widgets
                                        </span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#get_business_list"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Get business list
                                        </span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#receive_message_from_widget"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Receive message from widget
                                        </span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#send_message_using_agent"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Send message using agent
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[deployingImgArr[currentIndex]]}
                currentIndex={currentIndex}
                carousel={{ finite: true }}
            />
        </>
    )
}

export default Deployments